// import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const BannerContainerFluid = styled.div`
// border:2px dashed red;
width:100%;
margin-top:-200px;
min-height:700px;
background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1665054443/re-brand/banner-overlay.svg');
background-size:contain;
background-repeat:no-repeat;
background-position:bottom right;

@media screen and (max-width: 768px) {
  background:transparent;
  // border:2px dashed red;
}

`;



export const Container = styled.div
.attrs(() => ({
  className: 'container-custom',
}))`
`;

export const HeadingText = styled.h1
.attrs(() => ({
  className: '',
}))`
width: 538px;
font-family: 'Cabinet Grotesk-bold';
font-style: normal;
font-weight: 800;
font-size: 50px;
line-height: 103%;
/* or 52px */
color: #282828;
margin-bottom:0px !important;
@media screen and (max-width: 425px) {
    width:auto !important;
}

`;
export const DescText = styled.p
.attrs(() => ({
  className: '',
}))`
min-height: 56px;
font-family: 'Cabinet Grotesk';
font-style: normal;
font-weight: 300;
font-size: 21px;
line-height: 135.5%;
/* or 28px */


color: #4A4A4A;
`;



export const Button  = styled.a
.attrs(() => ({
  className: ' btn btn-large btn-flat  ',
}))`
background: linear-gradient(113.57deg, rgba(0, 165, 104, 0.2) 22.35%, rgba(0, 165, 104, 0.05) 71.76%);
:hover{
background: linear-gradient(113.57deg, rgba(0, 165, 104, 0.2) 22.35%, rgba(0, 165, 104, 0.05) 71.76%);
color: rgba(74, 74, 74, 0.8);
}
border-radius: 11.2069px;

font-family: 'Cabinet Grotesk' !important;
font-style: normal;
font-weight: 700;
font-size: 14.9425px;
line-height: 135.5%;
width:200.84px;
height: 65px;
color: rgba(74, 74, 74, 0.8);
margin-top:10px;
display:flex;
    span{
        font-family: 'Cabinet Grotesk' !important;
        font-style: normal;
        font-weight: 500;
        font-size: 9.71264px;
        line-height: 135.5%;
        color: rgba(74, 74, 74, 0.8);
    }

@media screen and (max-width: 500px) {
font-size: 1.8rem;
padding: 9px 1.5rem;
}
@media screen and (max-width: 400px) {
font-size: 1.4rem;
}
`;
